import '@/styles/global.css'
import { bootstrap } from '@/app/bootstrap'

bootstrap()
